<h2 mat-dialog-title>Guía de Modelo de Juego</h2>

<mat-dialog-content class="help-content">
  <section>
    <h3>Estructura</h3>
    <p>
      El modelo de juego se escribe como una secuencia de bloques separados por <code>-</code>.
      Cada bloque tiene <strong>acción + posición + tiempo de finalización</strong>.
    </p>
    <p>
      Un código completo tendría un formato del estilo <code>APMMSS-AMMSS-APMMSS-APMMSS</code>,
      donde <strong>A</strong> representa la acción, <strong>P</strong> la posición y <strong>MMSS</strong>
      el tiempo de finalización.
    </p>
    <p>
      <strong>Posiciones (opcionales):</strong> <code>I</code> izquierda, <code>C</code> centro y
      <code>D</code> derecha.
    </p>
    <p>
      <strong>Tiempo de finalización (últimos 4 dígitos):</strong> representa el minuto y segundo exacto
      del vídeo en el que acaba una acción, en formato <code>MMSS</code>. Por ejemplo, <code>1435</code>
      indica el minuto 14 y segundo 35 (<code>14:35</code>).
    </p>
  </section>

  <section>
    <h3>Posiciones</h3>
    <ul>
      @for (position of positions; track position.code) {
        <li><code>{{ position.code }}</code>: {{ position.description }}</li>
      }
    </ul>
  </section>

  <section>
    <h3>Ejemplos</h3>
    <ul>
      @for (example of examples; track example) {
        <li><code>{{ example }}</code></li>
      }
    </ul>
  </section>

  <section>
    <h3>Acciones conocidas</h3>
    <p>
      Esta tabla sirve como referencia para interpretar y editar. La validación es laxa para permitir
      futuras ampliaciones del catálogo.
    </p>
    <div class="actions-table-wrapper">
      <table class="actions-table">
        <thead>
          <tr>
            <th>Código</th>
            <th>Descripción</th>
          </tr>
        </thead>
        <tbody>
          @for (action of actions; track action.code) {
            <tr>
              <td><code>{{ action.code }}</code></td>
              <td>{{ action.description }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </section>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="close()">
    Cerrar
  </button>
</mat-dialog-actions>
